export interface AppConfig {
    apiBaseUrl: string;
    applicationInsightsKey: string;
    appName: string;
    buildNumber: string;
    checkVersionUpdateMs: number;
    defaultApiTimeoutMs: number;
    disableRawApiErrors: boolean;
    goUrl: string;
    messageCheckIntervalMs: number;
}

export const initializeAppConfig = () => {
    if (window.appConfig) return;
    window.appConfig = {
        apiBaseUrl: getEnv("api_base_url"),
        applicationInsightsKey: getEnv("application_insights_key"),
        appName: getEnv("name"),
        buildNumber: getEnv("build_number") ?? "unknown",
        checkVersionUpdateMs: parseFloat(
            getEnv("check_version_update_ms") ?? "900000"
        ),
        defaultApiTimeoutMs: parseFloat(
            getEnv("default_api_timeout_ms") ?? "30000"
        ),
        disableRawApiErrors: getEnv("disable_raw_api_errors") === "true",
        goUrl: getEnv("go_url"),
        messageCheckIntervalMs: parseFloat(
            getEnv("message_check_interval_ms") ?? "900000"
        ),
    };
};

const getEnv = (name: string) =>
    process?.env?.["REACT_APP_" + name.toUpperCase()];
